import {axios as request} from '@/utils/request'

// 查询已办任务列表
export function finishedList(query) {
  return request({
    url: '/jeecg-engineering/flowable/task/finishedList',
    method: 'get',
    params: query
  })
}

// 任务流转记录
export function flowRecord(query) {
  return request({
    url: '/jeecg-engineering/flowable/task/flowRecord',
    method: 'get',
    params: query
  })
}

// 撤回任务
export function revokeProcess(data) {
  return request({
    url: '/jeecg-engineering/flowable/task/revokeProcess',
    method: 'post',
    data: data
  })
}

// 部署流程实例
export function deployStart(deployId) {
  return request({
    url: '/jeecg-engineering/flowable/process/startFlow/' + deployId,
    method: 'get',
  })
}

